import { render, staticRenderFns } from "./LandingHeroAfiliado.vue?vue&type=template&id=2c4972fa&scoped=true"
import script from "./LandingHeroAfiliado.vue?vue&type=script&lang=js"
export * from "./LandingHeroAfiliado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4972fa",
  null
  
)

export default component.exports